import { styled } from '@mui/material'
import Box from '@mui/material/Box'

const Container = styled(Box)`
  height: 100%;
  width: 100%;
  padding: 0 21px;
  display: flex;
  flex-direction: column;
`

const Header = styled(Box)`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.palette.common.white};
  border-bottom: 2px solid ${({ theme }) => theme.palette.primary.main};
`
const Body = styled(Box)`
  flex: 1;
  display: flex;
  padding-top: 40px;
  background: ${({ theme }) => theme.palette.common.white};
`

export { Container, Header, Body }
